import { SystemEventListPanel } from "@/features/admin/components/system-event-list-panel";

/** Events Manager (`/admin/events`) — the platform-wide news/events feed. */
export default function EventsPage() {
  return (
    <SystemEventListPanel
      title="Events"
      description="News and events shown on every firm's dashboard feed."
      addLabel="Add Event"
      resource="events"
      fields={["eventDate", "eventTime", "title", "href", "detail"]}
      columns={[
        { header: "Date", cell: (e) => e.eventDate ?? "—" },
        { header: "Time", cell: (e) => e.eventTime || "—" },
        { header: "Title", cell: (e) => <span className="font-medium">{e.title}</span> },
      ]}
    />
  );
}
